import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "name",
  "aircraft",
  "period",
  "projection",
  "due",
  "overdue",
  "man_hours",
  "created",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const FIXED_COLUMNS: Column[] = ["number", "name"]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "Forecast no.",
  name: "Forecast",
  aircraft: "Aircraft",
  period: "Period",
  projection: "Projection",
  due: "Tasks due",
  overdue: "Overdue",
  man_hours: "Man-hrs",
  created: "Created",
}

export type Slot = Column | "actions"

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "forecasts",
  widths: {
    number: 9,
    name: 16,
    aircraft: 9,
    period: 10,
    projection: 8.5,
    due: 5.5,
    overdue: 5,
    man_hours: 5,
    created: 7,
    actions: 3.25,
  },
  fill: "name",
  pinned: ["actions"],
  extras: ["actions"],
  dropOrder: ["projection", "period", "man_hours", "overdue", "created"],
}

export function slotsOf(columns: Column[]): Slot[] {
  return [...columns, "actions"]
}

export function withFixed(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => FIXED_COLUMNS.includes(column) || columns.includes(column),
  )
}
